import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {HomeModule} from "./modules/home/home.module";
import {ErroModule} from "./modules/erro/erro.module";
import {CadastroModule} from "./modules/cadastro/cadastro.module";
import {AuthModule} from "./modules/auth/auth.module";
import {AutenticacaoGuard} from "./core/guards/autenticacao-guard";
import {TrabalhoModule} from "./modules/trabalho/trabalho.module";
import {EmpresaModule} from "./modules/cadastro/empresa/empresa.module";
import {GestaoModule} from "./modules/gestao/gestao.module";
import {AjudaModule} from "./modules/ajuda/ajuda.module";
import { UsuarioModule } from './modules/auth/usuario/usuario.module';
import { NotificacaoComponent } from './core/componentes/notificacao/notificacao.component';
import {ComunicacaoModule} from "./modules/comunicacao/comunicacao.module";
import { SecretariaModule } from './modules/secretaria/secretaria.module';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => AuthModule
  },
  {
    path: 'venda-ativa',
    loadChildren: () => import('./modules/venda-ativa/venda-ativa.module').then(m => m.VendaAtivaModule),
    canActivate: [AutenticacaoGuard]
  },
  {
    path: '',
    loadChildren: () => HomeModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'comunicacao',
    loadChildren: () => ComunicacaoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'notificacoes',
    component: NotificacaoComponent,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'trabalho',
    loadChildren: () => TrabalhoModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'cadastro',
    loadChildren: () => CadastroModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'gestao',
    loadChildren: () => UsuarioModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'empresa',
    loadChildren: () => EmpresaModule
  },
  {
    path: 'ajuda',
    loadChildren: () => AjudaModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: 'secretaria',
    loadChildren: () => SecretariaModule,
    canActivate: [AutenticacaoGuard]
  },
  {
    path: '**',
    pathMatch: "full",
    loadChildren: () => ErroModule
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
